import React, {FC} from 'react';
import styled from 'styled-components';

import {fontWeights} from '../../styles/fontStyles';
import {ellipsis} from '../../styles/mixins';
import {PaletteColorsEnum} from '../../styles/paletteModel';

/*
 * Props.
 */

export interface DropdownItemContentProps {
  isChecked?: boolean;
  isBold?: boolean;
  className?: string;
  isEditingWorkspace?: boolean;
  color?: PaletteColorsEnum;
}

/*
 * Style.
 */

interface ContentStyleProps {
  $isBold?: boolean;
  $color?: PaletteColorsEnum;
}
const StyledContentDiv = styled.div<ContentStyleProps>`
  grid-area: content;
  max-width: 100%;
  min-height: 20px;

  color: ${(p) => (p.$color && p.theme.palette[p.$color].shade40) || p.theme.greys.shade80};
  font-weight: ${(p) => (p.$isBold ? fontWeights.semibold : fontWeights.normal)};
  line-height: 20px;
  ${ellipsis()};
`;

/*
 * Component.
 */

export const DropdownItemContent: FC<DropdownItemContentProps> = (props) => {
  const {isChecked, isBold, isEditingWorkspace, children, className, color} = props;
  const renderAsBold = Boolean(isBold || isChecked);

  return (
    <StyledContentDiv $isBold={renderAsBold && !isEditingWorkspace} className={className} $color={color}>
      {children}
    </StyledContentDiv>
  );
};
